import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT_LINE_ITEM } from "./apiRoutes";

const mutateAddLineItemComment = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${PARK_DOCUMENT_LINE_ITEM}/comments`, data);
};

const useAddLineItemCommentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddLineItemComment,
    ...queryParams,
  });

export default useAddLineItemCommentMutation;
